export default __webpack_public_path__ + "media/zurb/img/events/speaking/lessons-5df6070317270f6bf6fc978591450fa9.png";